<template>
    <div width="1000" footer-hide>
        <Table border :columns="columns" @on-row-click="rowClick" :data="tableData"
            no-data-text="<div class='table-no-data'></div>" :height="300">

            <template slot-scope="{ row, index }" slot="flowStatus">
                <Tag :color="flowStatus[row.ffstatus].color">
                    {{ flowStatus[row.ffstatus].name }}</Tag>


            </template>
            <template slot-scope="{ row, index }" slot="action">
                <Button :disabled="readonly" type="error" size="small" @click="del(row)">撤回</Button>
            </template>
        </Table>
    </div>
</template>
<script>
export default {
    props: ['readonly'],
    data() {
        return {
            openForm: false,
            columns: [
                {
                    title: "车牌号",
                    key: "carNo",
                },
                {
                    title: "行车状态",
                    slot: "flowStatus",
                },
                {
                    title: "当前环节",
                    key: "nodeName",
                },
                {
                    title: "司机姓名",
                    key: "driver",
                },
                {
                    title: "调度时间",
                    key: "createTime1",
                }, {
                    title: "调度人员",
                    key: "creator",
                }, {
                    title: "操作",
                    slot: "action",
                },
            ],
            tableData: [],
            searchItem: {
                "pageNumber": 1,
                "pageSize": 50,
                "startTime": "",
                "endTime": "",
                "ono": "",
                "carNo": "",
                "customer": "",
                "driver": "",
                "keyword": "",
                "driverAccount": ""
            },
            flowStatus: {
                0: {
                    name: '未开始',
                    color: 'red'
                },
                1: {
                    name: '运输中',
                    color: 'warning'
                },
                2: {
                    name: '已完成',
                    color: 'success'
                }
            }

        }
    },
    methods: {
        open(v) {
            
            this.searchItem.ono = v.ono;
            //console.log('调度历史传参',this.searchItem);
            this.openForm = true;
            this.getList();
            
        },
        rowClick(v) {
            if (this.readonly) {
                this.$emit('obj', v); 
                this.openForm = false
            }
        },
        getList() {
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-ofc-server-web/dispatchDriver/list",
                data: this.searchItem,
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                if (res) {
                    // console.log(res);

                    var data = res.data.data.dataList;
                    var type = {
                        0: '大陆司机',
                        1: '香港司机',
                        2: '大陆香港司机'
                    }


                    for (let i = 0; i < data.length; i++) {
                        data[i].type1 = type[data[i].type];
                        data[i].ffstatus = 1;
                        // data[i].flowStatus1 = flowStatus[data[i].flowStatus];
                        data[i].createTime1 = this.utils.time(data[i].createTime);
                        this.diaoduStatus(data[i]);

                    }
                    this.tableData = data;
                    
                }
            });
        },
        diaoduStatus(data) {
            var jdStartTime = data.jdStartTime;
            var jdFinishTime = data.jdFinishTime;
            if (jdStartTime == null) {
                data.ffstatus = 0;
            }
            if (jdStartTime != null && jdFinishTime == null) {
                data.ffstatus = 1;
            }
            if (jdStartTime != null && jdFinishTime != null) {
                data.ffstatus = 2;
            }
        },
        del(row) {
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-ofc-server-web/dispatchDriver/del",
                data: { idList: [row.id] },
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                if (res) {
                    console.log(res);
                    // console.log(res);

                    this.getList();
                }
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/diaodu/diaoduNew/diaoduHistory.vue